import { useEffect, useState, useRef } from "react";
import { FaAngleDown } from "react-icons/fa";
import { SlClose } from "react-icons/sl";
import SideBar from "./SideBar";
import { networkSetup } from "../utils/networkSetup";
import { useWallet } from "@binance-chain/bsc-use-wallet";
import config from "./config";
import $ from "jquery";
import {
  useCRANK,
  useLP_2
} from "../hooks/useContract";
import useWeb3 from "../hooks/useWeb3";
import { Link } from "react-router-dom";

export default function Navbar(props) {
  const offcanvasBtn = useRef(null);
  const Web3 = require("web3");
  const currentChainId = parseInt(process.env.REACT_APP_CHAIN_ID, 10);
  const [address, setaddress] = useState();
  const [balance, setBalance] = useState(0);
  const [dxo, setDxoPrice] = useState(0);
  const { account, connect, reset } = useWallet();

  const crankContract = useCRANK();
  const LP_2Contract = useLP_2();
  const web3 = useWeb3();

  const [theme, setTheme] = useState(props.theme ? props.theme : "dark");

  const onDismiss = () => {
    $(".modal").removeClass("in");
    $(".modal-backdrop").remove();
    $("body").removeClass("modal-open");
    $("body").css("padding-right", "");
    $("body").css("overflow", "scroll");
    $(".modal").hide();
  };

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const postConnect = async (x) => {
    window.sessionStorage.setItem("accountType", x);
    window.sessionStorage.setItem("accountStatus", "1");
    await onDismiss();
  };

  const getCrankPrice = async () => {
    let crankBalance = await crankContract.methods.balanceOf(account).call();
    crankBalance = await (crankBalance / 1e18).toFixed(2);
    setBalance(crankBalance);
  }

  const getDxoPrice = async () => {
    let value = await LP_2Contract.methods.getReserves().call();
    let crankPrice = await ((parseInt(value["_reserve1"]) / parseInt(value["_reserve0"]))).toFixed(4)
    await setDxoPrice(crankPrice)
  }

  useEffect(() => {
    getDxoPrice()
    if (account) {
      getCrankPrice();
    }
    window.intervalPrice = setInterval(
      () => {
        getDxoPrice()
        if (account) {
          getCrankPrice();
        }
      },
      15000
    )
    return () => {
      clearInterval(window.intervalPrice)
    }
  }, [account]);

  const closeCanvas = async () => {
    onDismiss();
    offcanvasBtn.current.click();
  }

  useEffect(() => {
    let accountType = sessionStorage.getItem("accountType");
    if (accountType && !account) {
      console.log(accountType && !account)
      connect(accountType);
      onDismiss();
    }
  }, [props.search]);

  return (
    <>
      <div className="container header my-3">
        <div className="row align-items-center">
          <div className="col-lg-2 col-4 col-md-3">
            <Link to="/" className="d-lg-block d-none">
              <span>
                <img src={props.theme == "dark" ? "/logo.png" : "/darkLogo.png"} alt="logo" className="logoSize" />
              </span>
            </Link>
            <a
              data-bs-toggle="offcanvas"
              href="#offcanvasExample"
              role="button"
              aria-controls="offcanvasExample"
              className="d-lg-none "
            >
              <span>
                <img src={theme == "dark" ? "/logo.png" : "/darkLogo.png"} alt="logo" className="logoSize" />
              </span>
            </a>
          </div>
          <div className="col-lg-10 col-md-9 col-8">
            <div className={`d-flex align-items-center ${props.search ? "justify-content-between" : "justify-content-end"}`}>
              <div className={`searchBar  d-none ${props.search ? "d-lg-block" : ""}`}>
                <div className="input-group rounded search_bar">
                  <span className="mt-1 ps-3" style={{ color: "#9c9daf" }}>
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="search"
                    className="form-control rounded"
                    placeholder="Search pools"
                    aria-label="Search"
                    aria-describedby="search-addon"
                  />
                </div>
              </div>


              {/* <button className={`btn mx-3  d-none btn_m_s no-rap${props.search ?"d-lg-block d-md-block" :""}`}>
                Migrate and stake
              </button> */}
              <div className="d-flex justify-content-center align-items-center">
                {/* <a href="https://nomics.com/assets/dxo3-deflationary-xchange-output" target="_blank">
                  <img className="d-none d-lg-block" src={theme == "dark" ? "/Nomics_Logomark_Horz-Purple-White.png" : "/Nomics_Logomark_Horz-Purple.png"} height="50px" />
                  <img className=" d-lg-none" src="/Nomics_Graphicmark-Purple_200x200.png" height="25px" />
                </a> */}
                <a href="https://pancakeswap.finance/swap?inputCurrency=0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56&amp;outputCurrency=0xb39b58014A43dc1Da820dBc2a3BF4dBAE08206A4" target="_blank">
                  <h5 className="mb-0 d-lg-block d-none"><b><small >DXO Price : </small> {dxo} USD</b></h5>
                </a>
                <button
                  className="btn mx-lg-5 mx-md-3 mx-2 btn-sm btn_mode"
                  onClick={props.themeHandle}
                >
                  <i className="bi bi-moon-fill"></i>
                </button>



                {!account
                  ? <button
                    type="button"
                    className="btn btn_m_s no-rap" data-bs-toggle="modal" data-bs-target="#exampleModal"
                  >
                    <i className="icon icon-clone-regular"></i> Connect to a
                    wallet
                  </button>
                  : <>
                    <div className=" mx-lg-4 mx-2 nav_th">
                      <h6 className="mb-0 accountAddress">{account.substring(0, 5)} .... {account.substring(account.length, account.length - 5)}</h6>

                      <span style={{ color: "#9799a8" }}>BSC </span>

                    </div>
                    <div className="text-right">
                      <button
                        type="button"
                        className="btn btn-danger accountAddress" onClick={reset}
                      >
                        Disconnect wallet
                      </button><br />
                      <p className="pt-1 accountAddress">Balance : {balance}</p>
                    </div>
                  </>
                }

              </div>

            </div>
            <a href="https://pancakeswap.finance/swap?inputCurrency=0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56&amp;outputCurrency=0xb39b58014A43dc1Da820dBc2a3BF4dBAE08206A4" target="_blank">
              <p className="mb-0 d-lg-none pt-3 "><b><small >DXO Price : </small> {dxo} USD</b></p>
            </a>
          </div>
        </div>
      </div>
      <div
        className={`offcanvas offcanvas-start ${theme == "dark" ? "bg-theme" : ""}`}
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <img src={theme == "dark" ? "/logo.png" : "/darkLogo.png"} alt="logo" className="w-25" />
          <button
            type="button"
            className="offcanvasCloseBtn"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            ref={offcanvasBtn}
          >
            <SlClose size={28} />
          </button>
        </div>
        <div className="offcanvas-body">
          <SideBar close={closeCanvas} />
        </div>
      </div>
      <div
        className="modal fade wlltmdl" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-centered-custom" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Connect to a wallet</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body py-3">
              {/* <button className="btn-block text-dark" style={{ backgroundColor: 'transparent', border: 'none',  borderBottom: "1px solid #ffc300"  }} onClick={connect}><img src="data:image/png;base64,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" /><br />Metamask</button> */}
              {config.map((entry, index) => (
                <button
                  key={index}
                  className="mdl_c_btn"
                  onClick={() => {
                    if (Boolean(true)) {
                      networkSetup(currentChainId)
                        .then(async () => {
                          await connect(entry.connectorId);
                          // console.log(entry.connectorId);
                          await postConnect(entry.connectorId)
                        })
                        .catch((e) => {
                          console.error(e);
                        });
                    }
                  }}
                >
                  {entry.title}
                  <img src={entry.icon} height="35" width="35" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
